<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalMethodsMixin, globalVariablesMixin } from '../../Mixins/global'
import BlockContent from '../UI/Content/BlockContent.vue'

export default {
  components: { BlockContent },
  mixins: [mixinComponent, globalVariablesMixin, globalMethodsMixin],

  props: {
    entityId: { type: Number, required: true },
  },

  data: function () {
    return {
      financialStatement: {},
    }
  },

  beforeMount() {
    this.getJSON('entities/' + this.entityId + '/financial').then((json) => {
      this.financialStatement = json
    })
  },
}
</script>
<template>
  <BlockContent v-if="financialStatement">
    <div class="col card" style="padding: 1em; margin: 2em auto; overflow-x: auto">
      <h5 class="mb-3">{{ $t('entity.financialStatement.title') }}</h5>
      <table class="table table-striped table-hover fs-16">
        <tbody>
          <tr>
            <th>{{ $t('entity.financialStatement.taxReportFile') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ fin.taxReportFile ? fin.taxReportFile.id : '' }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.useMe') }}</th>
            <td v-for="(fin, index) in financialStatement">
              <i class="fa fa-check-circle text-success" v-if="fin.useMe"></i>
              <i class="fa fa-times-circle text-warning" v-else></i>
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.year') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ fin.year }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.source') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ fin.source }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.nbEmployees') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ fin.nbEmployees }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.accountAt') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ fin.accountAt ? setDate(fin.accountAt, 'date') : '' }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.nonCaptureCode') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ fin.nonCaptureCode }}
            </td>
          </tr>
          <tr style="border-top: 2px solid">
            <th>{{ $t('entity.financialStatement.stocks') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.stocks)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.receivables') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.receivables)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.otherReceivables') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.otherReceivables)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.securities') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.securities)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.total2') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.total2)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.total3') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.total3)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.adjustments') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.adjustments)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.totalAssets') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.totalAssets)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.socialCapital') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.socialCapital)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.equity') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.equity)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.supplierDebt') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.supplierDebt)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.otherOwnFunds') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.otherOwnFunds)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.provision') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.provision)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.otherDebt') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.otherDebt)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.totalDebt') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.totalDebt)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.conversionDiff') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.conversionDiff)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.generalTotal') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.generalTotal)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.financialliabilities') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.financialliabilities)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.shortDebt') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.shortDebt)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.empOblConv') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.empOblConv)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.otherEmpObl') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.otherEmpObl)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.empDebtEtb') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.empDebtEtb)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.empDebtEtb2') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.empDebtEtb2)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.empDebtFin') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.empDebtFin)) }}
            </td>
          </tr>
          <tr style="border-top: 2px solid">
            <th>{{ $t('entity.financialStatement.turnover') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.turnover)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.repriseAmort') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.repriseAmort)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.otherProducts') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.otherProducts)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.rex') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.rex)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.dotExp') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.dotExp)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.otherExpenses') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.otherExpenses)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.extraordinaryProfitLoss') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.extraordinaryProfitLoss)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.rn') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.rn)) }}
            </td>
          </tr>
          <tr style="border-top: 2px solid">
            <th>{{ $t('entity.financialStatement.consistency') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.consistency)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.totalAsset') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.totalAsset)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.totalLiability') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.totalLiability)) }}
            </td>
          </tr>
          <tr style="border-top: 2px solid">
            <th>{{ $t('entity.financialStatement.ebe') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.ebe)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.operatingCashFlow') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.operatingCashFlow)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.equityTotalAssets') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.equityTotalAssets)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.rexTurnover') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.rexTurnover)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.cashCa') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.cashCa)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.financialliabilitiesCashFlow') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.financialliabilitiesCashFlow)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.supplierDelay') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.supplierDelay)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.variationBfr') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.variationBfr)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.bfrStocks') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.bfrStocks)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.bfrReceivables') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.bfrReceivables)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.bfrOtherReceivables') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.bfrOtherReceivables)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.bfrSupplierDebt') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.bfrSupplierDebt)) }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('entity.financialStatement.bfrOtherDebt') }}</th>
            <td v-for="(fin, index) in financialStatement">
              {{ $n(Number(fin.bfrOtherDebt)) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </BlockContent>
</template>
